import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'ngxui-taskpane-recent-activity',
  templateUrl: './taskpane-recent-activity.component.html',
  styleUrls: ['./taskpane-recent-activity.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TaskpaneRecentActivityComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
